import { MutationTree } from 'vuex';
import { OrderPaymentState } from './types';

export enum OrderPaymentMutations {
  get_feedback_statistics = 'get_feedback_statistics',
  get_feedback_statistics_week = 'get_feedback_statistics_week',
  get_daily_statistics = 'get_daily_statistics',
  get_feedback_report = 'get_feedback_report',
  login_error = 'login_error'
}

export const mutations: MutationTree<OrderPaymentState> = {
  [OrderPaymentMutations.get_feedback_statistics](
    state,
    { feedbackStatistics }
  ) {
    state.feedbackStatistics = feedbackStatistics;
  },
  [OrderPaymentMutations.get_feedback_statistics_week](
    state,
    { feedbackStatisticsWeek }
  ) {
    state.feedbackStatisticsWeek = feedbackStatisticsWeek;
  },
  [OrderPaymentMutations.get_daily_statistics](state, { dailyStatistics }) {
    state.dailyStatistics = dailyStatistics;
  },
  [OrderPaymentMutations.get_feedback_report](state, { feedbackReport }) {
    state.feedbackReport = feedbackReport;
  },
  [OrderPaymentMutations.login_error](state, message: string) {
    state.status.error = true;
    state.status.message = message;
  }
};
